import { ProductType, QueryKey } from '@/enums';
import { ProductQueryParams } from '@/interfaces';
import { ProductEntity } from '@/pages/privatePages/product/types';
import { ProductService } from '@/services';
import { DEFAULT_PAGE_SIZE, PAGE_DEFAULT } from '@amili-v3/amili-v3-design';
import get from 'lodash/get';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export const productParams: ProductQueryParams = {
  q: 'BIO & ME Gut Health Test',
  productType: [ProductType.KIT],
};

export const useFetchProducts = (
  params?: ProductQueryParams,
  config?: Omit<
    UseQueryOptions<any, Error, ProductEntity, any>,
    'queryKey' | 'queryFn'
  >,
) => {
  const paramsData = {
    ...params,
    page: params?.page ?? PAGE_DEFAULT,
    take: params?.take ?? DEFAULT_PAGE_SIZE,
  };
  const { data: productsData, isLoading } = useQuery({
    queryKey: [{ key: QueryKey.PRODUCT.ALL, params: paramsData }],
    queryFn: () => ProductService.getAll(paramsData),
    ...config,
    meta: {
      ...config?.meta,
      showError: config?.meta?.showError ?? true,
    },
  });

  const products: ProductEntity[] = get(productsData, 'data.data', []);

  return { products, isLoading };
};
